module.exports = __webpack_public_path__ + "img/abc_logo.8580912f.png";